import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import JoditEditor from "jodit-react";

class ReturnRefundPolicy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user_id: localStorage.getItem("user_id"),
      page_type: props.page_type || "ReturnRefundPolicy",
      title: "",
      description: "",
      loading: false,
    };

    this.editor = null;

    this.editorConfig = {
      readonly: false,
      placeholder: "Write your return & refund policy here...",
      height: 500,
      minHeight: 400,
      toolbarAdaptive: false,
      buttons: [
        "source",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "align",
        "|",
        "link",
        "image",
        "video",
        "table",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "fullsize",
      ],
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
    };
  }

  componentDidMount() {
    this.fetchExistingData();
  }

  fetchExistingData = async () => {
    const { user_id, page_type } = this.state;

    if (!user_id || !page_type) {
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await axios.get("/additional_pages", {
        params: {
          user_id,
          page_type,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = res?.data?.data;

      this.setState({
        title: data?.title || "",
        description: data?.description || "",
      });
    } catch (error) {
      console.error("Fetch Error:", error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to load page data.",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  handleTitleChange = (e) => {
    this.setState({
      title: e.target.value,
    });
  };

  handleEditorChange = (content) => {
    this.setState({
      description: content,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      user_id,
      page_type,
      title,
      description,
    } = this.state;

    // if (!user_id || !page_type) {
    //   Swal.fire(
    //     "Error",
    //     "User ID or page type missing.",
    //     "error"
    //   );
    //   return;
    // }

    if (!title.trim()) {
      Swal.fire(
        "Error",
        "Please enter a title.",
        "error"
      );
      return;
    }

    if (!description.trim() || description === "<p><br></p>") {
      Swal.fire(
        "Error",
        "Please enter the return & refund policy.",
        "error"
      );
      return;
    }

    try {
      this.setState({ loading: true });

      const formData = new FormData();

      formData.append("user_id", user_id);
      formData.append("page_type", page_type);
      formData.append("title", title.trim());
      formData.append("description", description);

      const res = await axios.post(
        "/additional_pages",
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire(
        "Success",
        res?.data?.message || "Return & refund policy saved successfully.",
        "success"
      );

      await this.fetchExistingData();
    } catch (error) {
      console.error("Save Error:", error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong.",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      title,
      description,
      loading,
    } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">

              <div className="card shadow-sm border-0 rounded-4">

                <div className="card-header py-3">
                  <h4 className="mb-0">Return & Refund Policy</h4>
                </div>

                <div className="card-body p-4">

                  <form onSubmit={this.handleSubmit}>

                    <div className="row g-4">

                      <div className="col-12">
                        <label
                          htmlFor="page-title"
                          className="form-label fw-semibold"
                        >
                          Title
                        </label>

                        <input
                          id="page-title"
                          type="text"
                          name="title"
                          className="form-control"
                          value={title}
                          onChange={this.handleTitleChange}
                          placeholder="Enter page title"
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label fw-semibold">
                          Description
                        </label>

                        <JoditEditor
                          ref={(editor) => {
                            this.editor = editor;
                          }}
                          value={description}
                          config={this.editorConfig}
                          tabIndex={1}
                          onBlur={this.handleEditorChange}
                        />
                      </div>

                    </div>

                    <div className="d-flex justify-content-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>

                  </form>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReturnRefundPolicy;